import { TForm } from "../models/TForm";
import * as ListingSuccessResponse2 from "../../../domain/models/ListingSuccessResponse2";
import * as ListingStatusCount1 from "../../../domain/models/ListingStatusCount1";
import * as ListingStatus1 from "../../../domain/models/ListingStatus1";
import * as TFormStatus from "../models/TFormStatus";

export type TSelectedStatus = ListingStatus1.T | "all";

type TListingsForm = TForm<
    {},
    {},
    ListingSuccessResponse2.T
>;

const newListingsForm = (): TListingsForm => ({
    status: TFormStatus.constants.UNTOUCHED,
    form: {},
    response: {},
    meta: ListingSuccessResponse2.newDefault(),
});

export class C {
    public selectedStatus: TSelectedStatus = "instructed_on_the_market";
    public addressSearch: string = "";
    public results: TListingsForm = newListingsForm();
    public statusCounts: Array<ListingStatusCount1.T> = [];
}

export const countForStatus = (counts: Array<ListingStatusCount1.T>, status: ListingStatus1.T): number =>
    counts.find((count) => count.status === status)?.count ?? 0;

export const totalCount = (counts: Array<ListingStatusCount1.T>): number =>
    counts.reduce((total, count) => total + count.count, 0);
